import { BlockText, GridContainer, selectThunkRecordById, ViewSection } from "@duosoftbg/nacid-components";
import { useTranslation } from "react-i18next";
import { RepresentativeType } from "../../../../../../constants/representativeType";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";

const RepresentativeViewSection = ({ record }) => {
  const { t } = useTranslation();
  const isRepresentative = record?.isRepresentative;
  const isUniversityRepresentative =
    isRepresentative && record?.representativeType === RepresentativeType.UNIVERSITY_REPRESENTATIVE;

  const nationalUniversitiesData = useAppSelector((state) => {
    return state.AppData.nationalUniversitiesData.data;
  });

  return (
    <ViewSection label={"t.representative.details"}>
      <GridContainer spacing={3} mt={0}>
        <BlockText
          propsGrid={{ md: 12 }}
          withGrid
          label={"l.person.isRepresentative"}
          text={record.isRepresentative ? t("l.yes") : t("l.no")}
        />
        {isRepresentative && (
          <>
            <BlockText
              withGrid
              label={"l.person.representative.type"}
              text={t(`l.person.representative.type.${record.representativeType}`)}
            />
            {isUniversityRepresentative && (
              <BlockText
                withGrid
                label={"l.university"}
                text={selectThunkRecordById(record.representedUniversity, nationalUniversitiesData)?.name}
              />
            )}
            {!isUniversityRepresentative && <BlockText withGrid label={"l.company"} text={record.representedCompany} />}
          </>
        )}
      </GridContainer>
    </ViewSection>
  );
};
export default RepresentativeViewSection;
